/*
 * LanguageProvider
 *
 * this component connects the redux state language locale to the
 * IntlProvider component and i18n messages (loaded from `site/translations`)
 */

import React from 'react'
import { connect } from 'redaction'
import PropTypes from 'prop-types'
import { IntlProvider } from 'sb-react-intl'


const LanguageProvider = ({ children, locale, messages }) => (
  <IntlProvider locale={locale} messages={messages[locale]}>
    {children}
  </IntlProvider>
)

LanguageProvider.propTypes = {
  locale: PropTypes.string,
  messages: PropTypes.object,
  children: PropTypes.node.isRequired,
}

export default connect({
  locale: 'models.ui.locale',
})(LanguageProvider)
